import { UserInfo } from '@mygpt/app/apis';
import { Http } from '@mygpt/app/http';
import { ActiveAddOnSubscription, ActivePlanSubscription } from '@mygpt/app/users';

/**
 * 获取用户信息
 * @param params
 * @returns
 */
export const getUserInfo = () => {
  const { get } = Http.use();
  return get<UserInfo>(`/users/me`);
};

export interface SendEmailVerificationParams {
  email: string;
}

/**
 * 发送邮箱验证
 * @param params
 * @returns
 */
export const sendEmailVerification = (params: SendEmailVerificationParams) => {
  const { ...rest } = params;
  const { post } = Http.use();
  return post(`/users/email-verifications`, rest);
};

export interface PatchUserConfigParams {
  [key: string]: boolean;
}
/**
 * 修改用户设置
 * @param params
 * @returns
 */
export const patchUserConfig = (params: PatchUserConfigParams) => {
  const { patch } = Http.use();
  return patch(`/users/configs`, { configs: params });
};

export interface GetUserQuotaParams {
  user_id: string;
}

export interface EffectiveQuotas {
  is_corporate: boolean;
  bot_quota: {
    used: number;
    limit: number;
    available: number;
  };
  message_quota: {
    used: number;
    limit: number;
    available: number;
  };
  web_page_quota: {
    used: number;
    limit: number;
    available: number;
  };
  multi_modal_parsing_quota: {
    used: number;
    limit: number;
    available: number;
  };
}

export interface UserQuota {
  user: {
    id: string;
    user_id: string;
    email: string;
    name: string;
    picture: string;
    locale: string;
    corporate: boolean;
    is_independent: boolean;
  };
  active_add_on_subscriptions: ActiveAddOnSubscription[];
  active_plan_subscription: ActivePlanSubscription;
  effective_quotas: EffectiveQuotas;
}

/**
 * 获取用户套餐余量
 * @param params
 * @returns
 */
export const getUserQuota = (params: GetUserQuotaParams) => {
  const { get } = Http.use();
  return get(`/user/quota/${params.user_id}`);
};

/**
 * 获取当前用户的配额信息
 * @returns 当前用户的配额信息
 */
export const getQuotaInfo = () => {
  const { get } = Http.use();
  return get(`/user/quota`);
};

export interface GetBotQuotaParams {
  botId: string;
}

export interface BotQuota {
  effective_quotas: EffectiveQuotas;
}

/**
 * 获取机器人套餐余量
 * @param params
 * @returns
 */
export const getBotQuota = (params: GetBotQuotaParams) => {
  const { get } = Http.use();
  return get<BotQuota>(`/user/quota/bot/${params.botId}`);
};
